import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

/**
 * Automatically start the spinner on the provided observable and stop it when the observable completes or errors
 */
export function withLoader<T>(loader: LoaderServiceLike) {
  return (source: Observable<T>) => {
    loader.loading = true;
    return source.pipe(finalize(() => (loader.loading = false)));
  };
}

interface LoaderServiceLike {
  loading: boolean;
}
